<script>
	import { Select, Segmented } from "@xbs/svelte-wx";
	import { capitalizeFirstLetter, localeContext } from "@xbs/lib-scheduler";
	import { createEventDispatcher, getContext } from "svelte";
	export let mode;

	const dispatch = createEventDispatcher();

	const locale = getContext(localeContext);
	const _ = locale.getGroup("scheduler");

	const config = getContext("schedulerConfig");
	$: ({ viewControl, views } = $config);
	let control;
	let localeModes;
	$: {
		localeModes = views.map(({ id, label }) => {
			const name = _(capitalizeFirstLetter(label));
			return { id, name, label: name };
		});
		switch (viewControl) {
			case "auto":
				control = localeModes.length > 3 ? "dropdown" : "toggle";
				break;
			case "none":
				control = null;
				break;
			case "dropdown":
			case "toggle":
				control = viewControl;
				break;
		}
	}
	$: value = mode;

	$: if (value) {
		dispatch("action", {
			action: "set-mode",
			data: { value },
		});
	}

</script>

{#if control === 'dropdown'}
	<Select options={localeModes} bind:value textField="name" />
{:else if control === 'toggle'}
	<Segmented options={localeModes} bind:value />
{/if}
